import React from 'react';
import styles from './eventDeskPostScore.scss';

const SwapIcon = () => {
    return (
        <div className={styles.editMatchScoreSwapButtonIcon}>
            <svg xmlns="http://www.w3.org/2000/svg" width="10" height="19" viewBox="0 0 10 19" fill="none">
                <g id="Group 25">
                    <g id="Group 16">
                        <g id="Group 13">
                            <rect id="Rectangle 5" x="4.3252" y="1" width="1.42857" height="17.1429" rx="0.714286" fill="#007BCE" />
                        </g>
                    </g>
                    <path id="Rectangle 56" d="M1 5.28516L5.04061 1.24455L9.08122 5.28516" stroke="#007BCE" strokeLinecap="round" />
                </g>
            </svg>
            <svg xmlns="http://www.w3.org/2000/svg" width="10" height="19" viewBox="0 0 10 19" fill="none">
                <g id="Group 24">
                    <rect id="Rectangle 6" x="5.67383" y="17.5703" width="1.42857" height="17.1429" rx="0.714286" transform="rotate(-180 5.67383 17.5703)" fill="#007BCE" />
                    <path id="Rectangle 57" d="M9 13.2852L4.95939 17.3258L0.91878 13.2852" stroke="#007BCE" strokeLinecap="round" />
                </g>
            </svg>
        </div>

    );
};

export default SwapIcon;
